// Vector math
export interface Vector2 {
  x: number
  y: number
}

export const length = (v: Vector2) => Math.sqrt(v.x * v.x + v.y * v.y)
export const normalize = (v: Vector2) => {
  const l = length(v)
  return { x: v.x / l, y: v.y / l }
}
export const add = (a: Vector2, b: Vector2) => ({ x: a.x + b.x, y: a.y + b.y })
export const subtract = (a: Vector2, b: Vector2) => ({
  x: a.x - b.x,
  y: a.y - b.y,
})
export const multiplyScalar = (v: Vector2, s: number) => ({
  x: v.x * s,
  y: v.y * s,
})
export const dot = (a: Vector2, b: Vector2) => a.x * b.x + a.y * b.y
export const round = (v: Vector2) => ({
  x: Math.round(v.x),
  y: Math.round(v.y),
})
export const centerOf = (min: Vector2, max: Vector2) => ({
  x: min.x + (max.x - min.x) * 0.5,
  y: min.y + (max.y - min.y) * 0.5,
})
export const rotate = (v: Vector2, angle: number) => {
  const cos = Math.cos(angle)
  const sin = Math.sin(angle)

  return {
    x: v.x * cos - v.y * sin,
    y: v.x * sin + v.y * cos,
  }
}
